module.exports = __webpack_public_path__ + "img/logo.c64ba35f.png";